// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","headline":"_2VZ8OfV6pCjbZciF18Vn1A","body":"_2lYHSCAcM6vA2s-47YYZeS","extraSmallMaxWidth":"767px","smallMinWidth":"768px","smallMaxWidth":"991px","mediumMinWidth":"992px","mediumMaxWidth":"1199px","largeMinWidth":"1200px","largeMaxWidth":"1499px","extraLargeMaxWidth":"undefined","title":"_1QJR2AwgkwF72VuJnmifaF _2VZ8OfV6pCjbZciF18Vn1A","message":"_2id8KVkVbLrc1PKSl3X9ai _2lYHSCAcM6vA2s-47YYZeS","addressContainer":"gLHOFOPu1jJLtf0eeLNU","addressCard":"_3RP6A93VsqhW4Hn2y2WnNQ","addressListSpinner":"_2xsb1KEDgEHWfs9k8sVOIK"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/choose-address/address-list/AddressList.css
// module id = 708
// module chunks = 0